export const NOMBRAR_EMOJI='NOMBRAR_EMOJI';
export const BUSQUEDA_EMOJI='BUSQUEDA_EMOJI';
export const BUSQUEDA_EMOJI_ERROR='BUSQUEDA_EMOJI_ERROR';
export const EMOJI_NO_RESULTADOS='EMOJI_NO_RESULTADOS';
export const LOADING_BUSQUEDA='LOADING_BUSQUEDA';
